import { call } from "../../funcStore";
import { logAction } from "../../api/logApi";

const styles = {
  bar: {
    display: "flex",
    background: "#fff",
    borderBottom: "1px solid #999999",
  },
  tab: {
    border: "1px solid #ddd",
    background: "#fff",
    padding: "18px 18px",
    fontSize: "0.95rem",
    color: "#555",
    cursor: "pointer",
    borderRight:"1px solid #999999",
    width:"33vw"
  },
  tabActive: {
    border: "1px solid #4b3f8f",
    background: "#4b3f8f",
    color: "#fff",
  },
};

const SCREEN_LIVE = "live";
const SCREEN_TREND = "trend";
const SCREEN_SEARCH = "search";

const TAB_OPTIONS = [
  { value: SCREEN_LIVE, label: "配信中" },
  { value: SCREEN_TREND, label: "急上昇" },
  { value: SCREEN_SEARCH, label: "検索" },
];

const NAVIGATE_FUNC = {
  [SCREEN_LIVE]: "app.navigateToLive",
  [SCREEN_TREND]: "app.navigateToTrend",
  [SCREEN_SEARCH]: "app.navigateToSearch",
};

function MainTabs() {
  const activeTab = call("app.getState");

  function handleTabClick(tab) {
    logAction("main_tab_click", { tab });
    call(NAVIGATE_FUNC[tab]);
  }

  return (
    <nav style={styles.bar}>
      {TAB_OPTIONS.map(({ value, label }) => (
        <div
          key={value}
          style={{
            ...styles.tab,
            ...(activeTab === value ? styles.tabActive : {}),
          }}
          onClick={() => handleTabClick(value)}
        >
          {label}
        </div>
      ))}
    </nav>
  );
}

export default MainTabs;
